/* eslint-disable @typescript-eslint/ban-ts-comment */
import {AxiosResponse} from "axios";
import {taxGuruAxios} from "../../axios";
import {coreAttachmentUrls} from "../../url";
import {CoreAttachmentDto, CoreAttachmentResult, Filter} from "@mm-products/java-multima-framework";
import {resolveContentType} from "../../../../utils/axiosUtils";

export const uploadAttachment = (file: File, toastId?: string): Promise<AxiosResponse<CoreAttachmentDto>> => {
    const formData = new FormData();
    const type = resolveContentType(file);
    formData.append("data", new Blob([file], { type }));
    return taxGuruAxios.post(coreAttachmentUrls.upload, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        params: {
            fileName: file.name,
        },
        // @ts-ignore
        toastId,
    });
};

export const listAttachments = (filter: Filter, signal?: AbortSignal, toastId?: string): Promise<AxiosResponse<CoreAttachmentResult>> => {
    return taxGuruAxios.post(coreAttachmentUrls.filter, filter, {
        signal,
        // @ts-ignore
        toastId,
    });
};
export const deleteAttachment = (attachmentId: string, toastId?: string): Promise<AxiosResponse<CoreAttachmentDto>> => {
    return taxGuruAxios.delete(coreAttachmentUrls.delete(encodeURIComponent(attachmentId)), {
        // @ts-ignore
        toastId,
    });
};
export const downloadAttachment = (attachmentId: string, toastId?: string, noErrorToast?: boolean): Promise<AxiosResponse<Blob>> => {
    return taxGuruAxios.get(coreAttachmentUrls.download(encodeURIComponent(attachmentId)), {
        // @ts-ignore
        toastId,
        noErrorToast: noErrorToast,
        responseType: "blob",
    });
};

export const getAttachment = (id: string, toastId?: string, signal?: AbortSignal, noErrorToast?: boolean): Promise<CoreAttachmentDto> => {
    return taxGuruAxios
        .get(coreAttachmentUrls.get(encodeURIComponent(id)), {
            // @ts-ignore
            toastId,
            signal,
            noErrorToast,
        })
        .then((res) => res.data);
};
